import { createFileRoute, redirect } from '@tanstack/react-router';

import { redirectToOnboardingWhenRequired } from '@/features/onboarding/route-guards';

export const Route = createFileRoute('/')({
    beforeLoad: async () => {
        await redirectToOnboardingWhenRequired();

        throw redirect({ to: '/home' });
    }
});
